import React from 'react'
import { InfoWindowF } from '@react-google-maps/api'
import BaiduInfoWindow from '@/component/map/baidu/BaiduInfoWindow'
import { useMapType } from '@/component/map/MapContext'
import { wgs84ToBd09 } from '@/util/coordTransform'

export interface UnifiedInfoWindowProps {
    position: { lat: number; lng: number }
    onCloseClick?: () => void
    children: React.ReactNode
}

const UnifiedInfoWindow: React.FC<UnifiedInfoWindowProps> = ({ position, onCloseClick, children }) => {
    const { mapType } = useMapType()

    if (mapType === 'baidu') {
        const [bdLat, bdLng] = wgs84ToBd09(position.lat, position.lng)
        return (
            <BaiduInfoWindow
                position={{ lat: bdLat, lng: bdLng }}
                onCloseClick={onCloseClick}
            >
                {children}
            </BaiduInfoWindow>
        )
    }

    return (
        <InfoWindowF
            position={position}
            onCloseClick={onCloseClick}
        >
            <>{children}</>
        </InfoWindowF>
    )
}

export default UnifiedInfoWindow
